import {
  Button,
  InputText,
  InputNumber,
  Loader,
  Logo,
  countriesMasks,
  countryCodeFromIndicatif,
  Indicatifs,
} from "@roole/package-webtoolkit-b2b";
import { useEffect, useState } from "react";
import "@roole/package-webtoolkit-b2b/build/styles/output.tailwind.css";
import "../../styles/index.tailwind.css";
import { IMMATRICULATION } from "../../helpers/regex";
import { QRCodeService } from "../../services/QrcodeService";
import { useGTM } from "../../hooks";
import SignatureContratIllu from "./signatureContratIllu.svg";

export const SignatureContrat: React.FC = () => {
  const { sendEvent, environnement } = useGTM();
  const [immat, setImmat] = useState("");
  const [phone, setPhone] = useState<{
    indicatif: Indicatifs;
    phone: string;
  }>();
  const [hasError, setHasError] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const countryCode = countryCodeFromIndicatif(phone?.indicatif ?? "+33");

  const handleSubmit = async () => {
    if (!phone) return;
    setHasError(false);
    setLoading(true);

    try {
      const qrService = QRCodeService.getInstance();
      const data = await qrService.generateQRCode(
        `${phone.indicatif}${phone.phone.replaceAll(" ", "")}`,
        immat
      );
      window.location.href = data;
    } catch (error) {
      setHasError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    const darkModeQuery = window.matchMedia("(prefers-color-scheme: dark)");
    sendEvent("page_view", {
      is_dark_mode: darkModeQuery.matches,
      page_category: "landing_qr_code",
      environnement,
    });

    document.body.classList.add("bg-sub-brand-light");

    return () => {
      document.body.classList.remove("bg-sub-brand-light");
    };
  }, []);
  return (
    <div
      style={{ minHeight: "100vh" }}
      className="h-full w-screen flex justify-center items-center p-XS "
    >
      <div
        className="flex flex-col gap-S justify-center items-center bg-neutral-extra-light rounded-S px-XS py-S"
        style={{ maxWidth: 600 }}
      >
        <Logo color="icons-dark" size={{ type: "width", value: 100 }} />

        <img src={SignatureContratIllu} alt="Illustration signer contrat " />

        <div className="flex flex-col gap-M ">
          <div className="flex flex-col gap-3XS ">
            <h3 className="heading-3 text-center ">
              Votre aventure Roole commence ici
            </h3>
            <p className="body-medium text-center ">
              Complétez les champs pour accéder au lien sécurisé et signer votre
              contrat.
            </p>
          </div>

          {loading && <Loader />}

          {!loading && (
            <div className="flex flex-col gap-3XS ">
              <InputText
                placeholder="AB-123-CD"
                mask="$$-###-$$"
                required
                uppercased
                value={immat}
                onChange={(newValue) => setImmat(newValue)}
                label="Immatriculation du véhicule"
                error={hasError}
                disabled={loading}
              />

              <InputNumber
                label="Téléphone mobile"
                placeholder={countriesMasks[countryCode].placeholder}
                countries={["FR", "GP", "MQ", "GF", "RE-YT", "MC", "CH"]}
                indicatif={phone?.indicatif ?? "+33"}
                value={phone?.phone ?? ""}
                required
                onChange={(indicatif, phone) => {
                  setPhone({ indicatif, phone });
                }}
                maxHeight={200}
                error={
                  hasError
                    ? "Aucun contrat n'est associé aux informations renseignées. Si le problème persiste, indiquez-le à votre concessionnaire."
                    : false
                }
                disabled={loading}
              />
            </div>
          )}

          <Button
            label="Signer mon contrat"
            size="large"
            variant="primary-brand"
            disabled={loading}
            onClick={() => {
              if (
                phone &&
                IMMATRICULATION.test(immat) &&
                countriesMasks[countryCode].regex.test(phone.phone)
              ) {
                sendEvent("signer_mon_contrat", {
                  page_category: "landing_qr_code",
                });

                setHasError(false);
                handleSubmit();
              } else {
                setHasError(true);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};
